import { render, staticRenderFns } from "./DashBoardRevision.vue?vue&type=template&id=2bce2dc5"
import script from "./DashBoardRevision.vue?vue&type=script&lang=js"
export * from "./DashBoardRevision.vue?vue&type=script&lang=js"
import style0 from "./DashBoardRevision.vue?vue&type=style&index=0&id=2bce2dc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports